import React from 'react';
import {CustomDialog, Dialog} from '@wix/wix-ui-tpa/cssVars';
import {useEnvironment, useExperiments} from '@wix/yoshi-flow-editor';
import {classes, st} from './EcomDialog.st.css';
import {SPECS} from '../../constants';

type DialogProps = React.ComponentProps<typeof Dialog>;
type CustomDialogProps = React.ComponentProps<typeof CustomDialog>;

export function EcomDialog(props: DialogProps): React.ReactElement {
  const {className, ...rest} = props;
  const {isMobile, isPreview} = useEnvironment();
  const {experiments} = useExperiments();

  const shouldAddHackClassNameForClassicMobilePreview = isMobile && isPreview;
  const ecomCheckoutBrandStyling = experiments.enabled(SPECS.ecomCheckoutBrandStyling);
  const dialogClassName = st(
    className,
    ecomCheckoutBrandStyling ? classes.formSectionColors : /* istanbul ignore next */ undefined,
    shouldAddHackClassNameForClassicMobilePreview ? classes.hackForClassicMobilePreview : undefined
  );

  return <Dialog {...rest} className={dialogClassName} />;
}

export function EcomCustomDialog(props: CustomDialogProps): React.ReactElement {
  const {className, ...rest} = props;
  const {isMobile, isPreview} = useEnvironment();
  const {experiments} = useExperiments();

  const shouldAddHackClassNameForClassicMobilePreview = isMobile && isPreview;
  const ecomCheckoutBrandStyling = experiments.enabled(SPECS.ecomCheckoutBrandStyling);
  const dialogClassName = st(
    className,
    ecomCheckoutBrandStyling ? classes.formSectionColors : /* istanbul ignore next */ undefined,
    shouldAddHackClassNameForClassicMobilePreview ? classes.hackForClassicMobilePreviewCustomDialog : undefined
  );

  return <CustomDialog {...rest} className={dialogClassName} />;
}
